import Accordion from 'accordion-js'

export default function(el) {
  new Accordion(el, {
    duration: 600,
    showMultiple: true,
  })
}
